module.exports = __webpack_public_path__ + "img/ph-news.c2b427a2.jpg";